import * as Yup from 'yup';
import React, { useEffect, useState } from 'react';
import { useFormik, Form, FormikProvider } from 'formik';
// material
import {
  Stack,
  TextField,
  Button,
  Box,
  Checkbox,
  Typography,
  Alert,
  CircularProgress
} from '@mui/material';
import { LoadingButton } from '@mui/lab';
// component
import { api } from 'src/Api';
import { Decryption, Encryption } from 'src/functions/function';
import { useTranslation } from 'react-i18next';
import palette from 'src/theme/palette';
import LoadingButtonWrapper from 'src/components/LoadingButtonWrapper';

// ----------------------------------------------------------------------

export default function RoleModal({ handleClose, refresh, edit, roleid }) {
  const { t } = useTranslation();
  const [loading, setloading] = useState(false);
  const [dataloading, setdataloading] = useState(false);
  const RegisterSchema = Yup.object().shape({
    roleName: Yup.string().required(t('RoleModal.required.0'))
  });

  const formik = useFormik({
    initialValues: {
      roleName: edit ? roleid?.name : ''
    },
    validationSchema: RegisterSchema,
    onSubmit: () => (edit ? AssignRoleToPermission(roleid.id) : CreateEditRole())
  });

  useEffect(() => {
    getPermissions();
  }, []);

  const [permissionList, setpermissionList] = useState([]);
  const [oldArray, setoldArray] = useState([]);

  function getPermissions() {
    // setloading(true);
    setdataloading(true);
    const myHeaders = new Headers();
    const token = localStorage.getItem('token');
    myHeaders.append('Authorization', `Bearer ${token}`);

    const roleIdEncrypted = edit ? Encryption(roleid?.id, process.env.REACT_APP_SECRET_KEY) : null;
    const url = roleIdEncrypted
      ? `${api.get_permissions}?role_id=${roleIdEncrypted}`
      : api.get_permissions;

    var requestOptions = {
      method: 'GET',
      headers: myHeaders,
      redirect: 'follow'
    };

    fetch(url, requestOptions)
      .then((response) => {
        if (response.status === 200) {
          return response.json();
        } else {
          throw new Error('Failed to get permissions');
        }
      })
      .then((result) => {
        setpermissionList(result.data);
        if (edit) {
          result.data.forEach((item) => {
            if (item.permission_types.length > 0) {
              item.permission_types.forEach((items) => {
                let id = JSON.stringify({ permissionId: item.id, typeId: items.id });
                setcheckArray((prevItems) => [...prevItems, id]);
                setoldArray((prevItems) => [...prevItems, id]);
              });
            }
          });
        }
      })
      .catch((error) => console.log('error', error))
      .finally(() => setloading(false));
  }

  function CreateEditRole() {
    setloading(true);
    var myHeaders = new Headers();
    const token = localStorage.getItem('token');
    myHeaders.append('Authorization', `Bearer ${token}`);
    var formdata = new FormData();
    formdata.append(
      'role_name',
      Encryption(formik.values.roleName, process.env.REACT_APP_SECRET_KEY)
    );

    var requestOptions = {
      method: 'POST',
      headers: myHeaders,
      body: formdata,
      redirect: 'follow'
    };

    fetch(api.roles, requestOptions)
      .then((response) => {
        if (response.status === 201) {
          return response.json();
        } else {
          setalert({ visible: true, message: 'Something went wrong please try again' });
        }
      })
      .then((result) => {
        let decryptedData = result.data;
        AssignRoleToPermission(decryptedData.id);
      })
      .catch((error) => {
        console.log('error', error);
      })
      .finally(() => setloading(false));
  }

  function AssignRoleToPermission(id) {
    setloading(true);
    const token = localStorage.getItem('token');
    var myHeaders = new Headers();
    myHeaders.append('accept', 'application/json');
    myHeaders.append('Content-Type', 'application/json');
    myHeaders.append('Authorization', `Bearer ${token}`);

    var requestOptions = {
      method: 'POST',
      headers: myHeaders,
      body: JSON.stringify({
        role_id: Encryption(id, process.env.REACT_APP_SECRET_KEY),
        values: Encryption(JSON.stringify(checkArray), process.env.REACT_APP_SECRET_KEY)
      }),
      redirect: 'follow'
    };

    fetch(api.add_role_with_per_and_type, requestOptions)
      .then((response) => {
        if (response.status === 201) {
          return response.json();
        } else {
          setalert({ visible: true, message: 'Something went wrong please try again' });
        }
      })
      .then((result) => {
        refresh();
      })
      .catch((error) => {
        console.log('error', error);
      })
      .finally(() => setloading(false));
  }

  const { errors, touched, handleSubmit, isSubmitting, getFieldProps } = formik;
  const [alert, setalert] = useState({ visible: false, message: '' });

  const [checkArray, setcheckArray] = useState([]);

  function CheckMark(id) {
    let obj = JSON.parse(id);
    //checking if exists already
    if (checkArray.includes(id)) {
      //if permission visible
      if (obj.typeId == 1) {
        setcheckArray(
          checkArray.filter((item) => {
            let object = JSON.parse(item);
            return object.permissionId !== obj.permissionId;
          })
        );
      } else {
        setcheckArray(checkArray.filter((item) => item != id));
      }
    } else {
      setcheckArray([...checkArray, id]);
    }
  }

  const renderPermission = (item, level = 0) => {
    const isParent = item.subRoutes?.length > 0;
    const isFirstPermissionType = (idx) => idx === 0;
    const isDependentOnView = (idx, item) =>
      !isFirstPermissionType(idx) &&
      !checkArray.includes(JSON.stringify({ permissionId: item.id, typeId: 1 }));

    return (
      <React.Fragment key={item.id}>
        {/* Parent or Child Permission Box */}
        <Box
          sx={{
            display: 'flex',
            flexDirection: 'column',
            flex: 1,
            py: isParent ? 1.5 : 0,
            pl: 2,
            pr: 2,
            mb: 0.5,
            ...(isParent && {
              backgroundColor: palette.primary.lighterMain,
              borderRadius: 1,
              borderLeft: '3px solid',
              borderColor: 'primary.main',
              px: 2,
              pt: 2
            })
          }}
        >
          {/* Parent / Child Permission Row */}
          <Box
            sx={{
              display: 'flex',
              flexDirection: 'row',
              alignItems: 'center',
              flexWrap: 'wrap'
            }}
          >
            {/* Permission Name */}
            <Typography
              sx={{
                width: isParent ? 150 : 140,
                fontFamily: isParent ? 'poppinsBold' : 'poppinsSemiBold',
                fontSize: isParent ? 14 : 13,
                color: isParent ? 'primary.main' : 'text.primary',
                textTransform: isParent ? 'uppercase' : 'none'
                // letterSpacing: isParent ? 0.5 : 0
                // mr: 2
              }}
            >
              {item.permission_name} {isParent ? '/' : ':'}
            </Typography>

            {/* Permission Types */}
            <Box sx={{ display: 'flex', flexWrap: 'wrap', gap: 1 }}>
              {item.allowed_permission_types.map((ptype, idx) => {
                const permissionId = JSON.stringify({ permissionId: item.id, typeId: ptype.id });

                return (
                  <Box
                    key={`${item.id}-${ptype.id}`}
                    sx={{
                      display: 'flex',
                      alignItems: 'center',
                      width: 160,
                      opacity: isDependentOnView(idx, item) ? 0.5 : 1
                    }}
                  >
                    <Checkbox
                      size="small"
                      sx={{
                        p: 0.5,
                        color: 'primary.main',
                        '&.Mui-checked': {
                          color: 'primary.main'
                        }
                      }}
                      disabled={isDependentOnView(idx, item)}
                      checked={checkArray.includes(permissionId)}
                      onChange={() => CheckMark(permissionId)}
                    />
                    <Typography
                      sx={{
                        fontSize: 12,
                        fontFamily: 'poppinsRegular',
                        color: isDependentOnView(idx, item) ? 'text.disabled' : 'text.primary'
                      }}
                    >
                      {ptype.permission_type_name}
                    </Typography>
                  </Box>
                );
              })}
            </Box>
          </Box>

          {/* SubRoutes Nested Inside Parent */}
          {isParent && item.subRoutes && item.subRoutes.length > 0 && (
            <Box sx={{ mt: 1.2, pl: 2 }}>
              {item.subRoutes.map((sub) => renderPermission(sub, level + 1))}
            </Box>
          )}
        </Box>
      </React.Fragment>
    );
  };

  return (
    <FormikProvider value={formik}>
      <Typography
        sx={{
          fontSize: 22,
          fontFamily: 'poppinsSemiBold',
          textAlign: 'center'
        }}
      >
        Role/Permissions
      </Typography>
      <Form autoComplete="off" noValidate onSubmit={handleSubmit}>
        <Stack direction={{ xs: 'column', sm: 'row' }}>
          <TextField
            disabled={edit}
            fullWidth
            label={t('RoleModal.role')}
            {...getFieldProps('roleName')}
            error={Boolean(touched.roleName && errors.roleName)}
            helperText={touched.roleName && errors.roleName}
            sx={{ mt: 1.5, mb: 1.5 }}
          />
        </Stack>

        <Typography
          sx={{ fontFamily: 'poppinsSemiBold', fontSize: 16, color: palette.primary.main, mb: 1 }}
          variant="subtitle1"
          noWrap
        >
          Permissions
        </Typography>
        <Box
          style={{
            display: 'flex',
            flexDirection: 'column'
          }}
        >
          {permissionList.length > 0 && <>{permissionList.map((item) => renderPermission(item))}</>}

          {dataloading && permissionList.length == 0 && (
            <Box
              py={5}
              style={{
                display: 'flex',
                justifyContent: 'center',
                flex: 1
              }}
            >
              <CircularProgress />
            </Box>
          )}
        </Box>

        {alert.visible && (
          <>
            <Alert
              onClose={() => {
                setalert({ visible: false, message: '' });
              }}
              severity="error"
            >
              {alert.message}
            </Alert>
          </>
        )}
        <Box
          style={{
            display: 'flex',
            flexDirection: 'row',
            justifyContent: 'flex-end',
            width: '100%',
            marginTop: 15
          }}
        >
          <LoadingButtonWrapper
            disabled={
              oldArray.toString() == checkArray.toString() || checkArray.length < 1 ? true : false
            }
            loading={loading}
            type="submit"
            variant="contained"
            sx={{
              width: loading ? 120 : 90,
              height: 30,
              fontSize: 12,
              borderRadius: 0.7,
              fontFamily: 'poppinsLight',
              letterSpacing: 0.3,
              transition: 'width 0.3s ease, background-color 0.3s ease, transform 0.3s ease'
            }}
            title="Save"
          />

          <Button
            onClick={handleClose}
            variant="outlined"
            sx={{
              ml: 1.5,
              color: palette.primary.pageButtonTitle,
              borderColor: palette.primary.pageButtonBorder,
              fontSize: 12,
              height: 30,
              fontFamily: 'poppinsRegular',
              borderRadius: 0.7,
              '&:hover': {
                backgroundColor: palette.primary.inputborder,
                borderColor: palette.primary.pageButtonBorder
              }
            }}
          >
            Cancel
          </Button>
        </Box>
      </Form>
    </FormikProvider>
  );
}
